module.exports = __webpack_public_path__ + "img/平台2   手机.68fff9d7.png";